// @ts-nocheck
import FieldDefinition, { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { PartialBy } from "@store/Framework/Types/Common";
import { GreifFieldDefinition } from "@store/Framework/Types/FieldDefinition";

/**
 * Converts a set of fieldDefinitions into a set of childFieldDefinitions
 *
 * @param fieldDefinitions FieldDefinitions to convert
 * @returns A set of childFieldDefinitions
 */
export default (fieldDefinitions: GreifFieldDefinition[]) => {
    return (
        (fieldDefinitions as PartialBy<FieldDefinition, "fieldType">[])?.map(x => {
            if (x.fieldType) {
                delete x.fieldType;
            }

            return x as ChildFieldDefinition;
        }) || []
    );
};
